
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import backgroundImage from '../assets/images/05.jpg';
import { Link, useParams } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';

function Sidebar() {

    const { id } = useParams();

    const { user, isAuth } = useContext(AuthContext)
    const [community, setCommunity] = useState([]);

    useEffect(() => {
        const token = Cookies.get('token');

        instance.get("/communities/getAll", token)
            .then(response => {
                             setCommunity(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des Communities:', error);
            });

    }, [])

    return (


        <>

            {user &&
                <>

                    <div className="d-flex align-items-center d-lg-none">
                        <button className="border-0 bg-transparent" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSideNavbar" aria-controls="offcanvasSideNavbar">
                            <span className="btn btn-primary"><i className="fa-solid fa-sliders-h" /></span>
                            <span className="h6 mb-0 fw-bold d-lg-none ms-2">My profile</span>
                        </button>
                    </div>

                    <nav className="navbar navbar-expand-lg mx-0">
                        <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasSideNavbar">
                            {/* Offcanvas header */}
                            <div className="offcanvas-header">
                                <button type="button" className="btn-close text-reset ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" />
                            </div>
                            {/* Offcanvas body */}
                            <div className="offcanvas-body d-block px-2 px-lg-0">
                                {/* Card START */}
                                <div className="card overflow-hidden">
                                    {/* Cover image */}
                                    <div className="h-50px" style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
                                    {/* Card body START */}
                                    <div className="card-body pt-0">
                                        <div className="text-center">
                                            {/* Avatar */}
                                            <div className="avatar avatar-lg mt-n5 mb-3">
                                                <a href="#!"><img className="avatar-img rounded border border-white border-3" src={user.profilePicture} alt /></a>
                                            </div>
                                            {/* Info */}
                                            <h5 className="mb-2"> <a href="#!">{user.firstName} {user.lastName}</a> </h5>
                                            {/* <small ><a target="_blank" href={user && user.link}>{user.link}</a></small> */}
                                            <div className="hstack gap-2 gap-xl-3 justify-content-center mt-4">
                                                {/* User stat item */}
                                                <div>
                                                    <h6 className="mb-0">{community && community.length}</h6>
                                                    <small>Communities</small>
                                                </div>
                                                {/* Divider */}
                                                <div className="vr">|</div>

                                                <div>
                                                    <h6 className="mb-0">{user && user.documents && user.documents.length}</h6>
                                                    <small>Projects</small>
                                                </div>
                                                {/* Divider */}
                                                <div className="vr">|</div>

                                                <div>
                                                    <h6 className="mb-0">{user && user.documents && user.connections.length}</h6>
                                                    <small>Connections</small>
                                                </div>
                                            </div>


                                        </div>
                                        <hr />

                                        <ul className="nav nav-link-secondary flex-column fw-bold gap-2">
                             
                                            {
                                                window.location.pathname === `/myprofil/${user.id}` ?
                                                    <>


                                                        <li className="nav-item">
                                                            <a className="nav-link active" href={"/myprofil/" + user.id} > <img className="me-2 h-20px fa-fw" src="../assets/images/icon/task-done-outline-filled.svg" alt /><span>Publications </span></a>
                                                        </li>
                                                    </> :
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link" href={"/myprofil/" + user.id} > <img className="me-2 h-20px fa-fw" src="../assets/images/icon/task-done-outline-filled.svg" alt /><span>Publications </span></a>
                                                        </li>
                                                    </>
                                            }
                                        
                                        {
                                                window.location.pathname === `/myproject/${user.id}` ?
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link active" href={"/myproject/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/calendar-outline-filled.svg" alt /><span>Projects</span></a>
                                                        </li>
                                                    </> :
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link " href={"/myproject/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/calendar-outline-filled.svg" alt /><span>Projects</span></a>
                                                        </li>
                                                    </>
                                            }
                                            {
                                                window.location.pathname === `/communities/${user.id}` ?
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link active" href={"/communities/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/handshake-outline-filled.svg" alt="" />
                                                                <span> Communities</span></a>
                                                        </li>
                                                    </> :
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link " href={"/communities/" + user.id}><img className="me-2 h-20px fa-fw" src="../assets/images/icon/handshake-outline-filled.svg" alt="" /><span>Communities</span></a>
                                                        </li>
                                                    </>
                                            }
                                           
                                            {
                                                window.location.pathname === `/connection/${user.id}` ?
                                                    <>
                                                        <li className="nav-item">
                                                            <a className="nav-link active " href={"/connection/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/person-outline-filled.svg" alt /><span>Connections </span></a>
                                                        </li>
                                                    </> :
                                                    <>

                                                        <li className="nav-item">
                                                            <a className="nav-link" href={"/connection/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/person-outline-filled.svg" alt /><span>Connections </span></a>
                                                        </li>
                                                    </>


                                            }


                                            
                                           {window.location.pathname === "/" ?
                                                <>



                                                    <li className="nav-item">
                                                        <a className="nav-link active" href={"/about/" + user.id} > <img className="me-2 h-20px fa-fw" src="../assets/images/icon/home-outline-filled.svg" alt /><span> About</span></a>
                                                    </li>
                                                </> :
                                                <>
                                                    <li className="nav-item">
                                                        <a className="nav-link   " href={"/about/" + user.id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/home-outline-filled.svg" alt /><span> About</span></a>
                                                    </li>
                                                </>
                                            }

                                        </ul>
                                        {/* Side Nav END */}
                                    </div>
                                    {/* Card body END */}
                                    {/* Card footer */}
                                    <div className="card-footer text-center py-2 mb-2">
                                        <Link className="btn btn-link btn-sm" to={"/editprofil/" + user.id}>
                                            <button className="BtnEditProfil">Edit
                                                <svg className="svgEditProfil" viewBox="0 0 512 512">
                                                    <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" /></svg>
                                            </button>


                                        </Link>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </nav>


                </>
            }
        </>
    )
}

export default Sidebar 